export function CalculaPercentual(pValor: number, pValPerc: number): number {
  return (pValor * pValPerc) / 100;
}
